import * as client from "_graphql-types";
import * as types from "./types";

type Sdk = ReturnType<typeof client.getSdk>;

/*********************************************************************/
// Data Provider Functions
/*********************************************************************/

/*********************************************************************/
async function getList(sdk: Sdk, params: types.GetListParams<client.PrivateQuartileGroupCategorySortEnum>) {
  const {
    pagination: { page, perPage },
    sort: { field, order },
    filter
  } = params;

  const {
    privateQuartileGroupCategoryList: { items: data, total }
  } = await sdk.getListPrivateQuartileGroupCategory({
    filter,
    page: {
      offset: (page - 1) * perPage,
      limit: perPage
    },
    sort: [{ field, order }]
  });

  return {
    data,
    total,
  };
}

/*********************************************************************/
async function getOne(sdk: Sdk, params: types.GetOneParams) {
  const id = Number(params.id);
  const { privateQuartileGroupCategory: data } = await sdk.getOnePrivateQuartileGroupCategory({
    id
  });
  return {
    data,
  };
}

/*********************************************************************/
async function getMany(sdk: Sdk, params: types.GetManyParams) {
  const ids = params.ids.map(Number);

  const {
    privateQuartileGroupCategoryMany: data
  } = await sdk.getManyPrivateQuartileGroupCategory({
    ids
  });

  return {
    data,
  };
}


/*********************************************************************/
export const privateQuartileGroupCategory = types.dataProvider({
  getList,
  getOne,
  getMany
});